// =====================================================
// 📁 POSSummaryPanel.tsx
// =====================================================

import { useSale } from '../../../../hooks/sale/useSale';

import { useSystemOperationMode } from '../../../../hooks/settings/useSystemOperationMode';

import POSSelectedProducts from './POSSelectedProducts';

import POSSummaryTotals from './POSSummaryTotals';

import POSFinalizeButton from './POSFinalizeButton';

import POSPaymentCondition from './POSPaymentCondition';

import POSPaymentMethods from './POSPaymentMethods';

import POSExportInvoicePanel from '../export/panel/POSExportInvoicePanel';
import POSGlobalDiscountSection from './POSGlobalDiscountSection';
import POSCommentSection from './POSCommentSection';

const POSSummaryPanel = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const {
    form,
  } = useSale();

  const { form: operationConfig } = useSystemOperationMode();

  // =====================================================
  // 🔹 Flags
  // =====================================================
  // ⚠️ Leer form.paymentCondition.code (no el paymentConditionCode suelto de
  // Redux): ese campo solo se actualiza cuando el usuario cambia la
  // condición manualmente, así que queda desincronizado cada vez que la
  // venta se recarga desde el servidor (p. ej. tras aplicar un descuento),
  // haciendo reaparecer "Forma de Pago" aunque la condición siga en "Otro".
  const isOtherCondition = form?.paymentCondition?.code === 'OTRO';

  const isPendingCashierMode =
    operationConfig.saleOperationMode === 'PENDING_CASHIER';

  // =====================================================
  // 🔹 Values
  // =====================================================
  const products = form?.products || [];

  const productsCount = products.length;

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <section
      className="
      sticky
      top-4
      h-fit

      overflow-hidden

      rounded-2xl

      border
      border-stroke

      bg-whiter

      shadow-1

      dark:border-strokedark
      dark:bg-boxdark-2
    "
    >
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}
      <div
        className="
        flex
        items-start
        justify-between

        border-b
        border-stroke

        bg-gray-2

        px-5
        py-4

        dark:border-strokedark
        dark:bg-boxdark
      "
      >
        <div>
          <h2
            className="
            text-lg
            font-semibold

            text-black

            dark:text-white
          "
          >
            Resumen de la Venta
          </h2>

          <p
            className="
            mt-1

            text-sm

            text-body

            dark:text-bodydark1
          "
          >
            Productos agregados al documento
          </p>
        </div>

        <div
          className="
          rounded-xl

          border
          border-primary/20

          bg-primary/10

          px-3
          py-1.5

          text-sm
          font-semibold

          text-primary
        "
        >
          {productsCount} {productsCount === 1 ? 'producto' : 'productos'}
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}
      <div className="space-y-5 p-5">
        {/* 🔹 Products */}
        <POSSelectedProducts />

        {/* 🔹 Totals */}
        <POSSummaryTotals />

        {/* 🔹 Global Discount */}
        <POSGlobalDiscountSection />

        {/* 🔹 Export Invoice */}
        <POSExportInvoicePanel />

        {/* ===================================================== */}
        {/* 🔹 Direct Sale Flow */}
        {/* ===================================================== */}
        {!isPendingCashierMode && (
          <>
            <POSPaymentCondition />

            {!isOtherCondition && <POSPaymentMethods />}
          </>
        )}

        {/* 🔹 Comentario interno / Apéndice del DTE */}
        <POSCommentSection />

        {/* 🔹 Finalize */}
        <div
          className="
          border-t
          border-stroke

          pt-5

          dark:border-strokedark
        "
        >
          <POSFinalizeButton />
        </div>
      </div>
    </section>
  );
};

export default POSSummaryPanel;
